const depatylist = {
    arkhangelsk: {
        title: "В этом году в Архангельской области выбирают губернатора",
        name: "Кандидат от ЛДПР Пивков Сергей Анатольевич",
        description: "Руководитель фракции ЛДПР в Архангельском областном Собрании депутатов. Доцент кафедры государственного и муниципального управления и менеджмента. Родился в Новодвинске, 36 лет.",
        photo: '<img src="/src/img/pivkov.png" alt="Пивков">',
         url: {
            vk: '<a href="https://vk.com/sapivkov" target="_blank">Вконтакте</a>',
            fb: '<a href="https://ru-ru.facebook.com/sapivkov" target="_blank">Фэйсбук</a>',
            inst: '<a href="https://www.instagram.com/s_a_pivkov/" target="_blank">Инстаграм</a>'
        },
        second: {
            url: {

            },
        }
    },
    komi: {
        title: "В этом году в республике Коми выбирают губернатора",
        name: "Кандидат от ЛДПР Никитин Андрей Андреевич",
        description: "Родился в Сыктывкаре. Депутат муниципального образования ГО «Усинск». Отец двоих детей, 30 лет.",
        photo: '<img src="/src/img/Коми-Губернатор-Никитин.png" alt="Пивков">',
        url: {
            vk: '<a href="https://vk.com/id5686131" target="_blank">Вконтакте</a>',
        },
        second: {
            url: {

            },
        }
    },
    lenin: {
        title: "В этом году в Ленинградской области выбирают губернатора",
        name: "Кандидат от ЛДПР Лебедев Андрей Ярославович",
        description: "Экс-депутат Государственной думы, депутат Законодательного собрания Ленинградской области. Женат, воспитывает двоих детей.",
        photo: '<img src="/src/img/Ленобласть-Губернатор-Лебедев.png" alt="Лебедев">',
        url: {
        },
        second: {
            url: {

            },
        }
    },
    yamal: {
        title: "В этом году в республике  выбирают депутатов Заксобрания",
        name: "Кандидаты от ЛДПР ",
        description: "Здесь будут кандидаты от ЛДПР",
        url: {
            vk: "vk.com",
            fb: "fb.com",
            inst: "null",
        },
        second: {
            url: {

            },
        }
    },

    kaluga: {
        title: "В этом году в Калужской области выбирают губернатора",
        name: "Кандидат от ЛДПР Опарышев Степан Степанович",
        description: "Родился в Обнинске, 33 года. Координатор Обнинского местного отделения ЛДПР, начальник отдела развития ООО «МироСтрой».",
        photo: '<img src="/src/img/Калуга-Губернатор-Опарышев.png" alt="Лебедев">',
        url: {
        },
        second: {
            url: {

            },
        }
    },
    kostroma: {
        title: "В этом году в Костромской области выбирают губернатора",
        name: "Кандидат от ЛДПР Федоров Руслан Владимирович",
        description: "30 лет, окончил Костромской государственный технологический университет и Институт Мировых Цивилизаций. Руководитель Костромского отделения ЛДПР.",
        photo: "<img src='/src/img/Фёдоров.svg' alt='Фёдоров'>",
        url: {
            vk: '<a href="https://vk.com/rus44rus" target="_blank">Вконтакте</a>',
            fb: '<a href="https://www.facebook.com/rus44rus" target="_blank">Фэйсбук</a>',
            inst: '<a href="https://www.instagram.com/fedorov44rus/" target="_blank">Инстаграм</a>',
        },
        second: {
            url: {

            },
        }
    },
    smolensk: {
        title: "В этом году в Смоленской области выбирают губернатора",
        name: "Кандидат от ЛДПР Алексей Владимирович Островский",
        description: "Губернатор Смоленской области, экс-депутат Госдумы, женат, воспитывает двух детей. Член Высшего совета ЛДПР.",
        photo: "<img src='/src/img/Смоленск-Губернатор-Островский.png' alt='Островский'>",
        url: {
            vk: '<a href="https://vk.com/ostrovskylive1" target="_blank">Вконтакте</a>',
            inst: '<a href="https://www.instagram.com/always_open_heart/" target="_blank">Инстаграм</a>',
        },
        second: {
            url: {

            },
        }
    },
    tambov: {
        title: "В этом году в Тамбовской области выбирают главу администрации",
        name: "Кандидат от ЛДПР Телегин Игорь Вячеславович",
        description: "Депутат Тамбовской областной Думы, заместитель председателя комитета по бюджету, налогам и финансам. 18 лет состоит в ЛДПР.",
        photo: '<img src="/src/img/Тамбов-Губернатор-Телегин.png" alt="Телегин">',
        url: {
        },
        second: {
            url: {

            },
        }
    },
    kursk: {
        title: "В этом году в Курской области выбирают депутата Государственной думы",
        name: "Кандидат от ЛДПР Томанов Алексей Юрьевич",
        description: "39 лет, координатор Курского регионального отделения ЛДПР, депутат Курского городского Собрания депутатов.Женат, воспитывает двух детей. Имеет высшее образование, 16 лет состоит в ЛДПР.",
        photo: '<img src="/src/img/Томанов.svg" alt="Томанов">',
        url: {
            vk: '<a href="https://vk.com/tomanovldpr" target="_blank">Вконтакте</a>',
        },
        second: {
            url: {

            },
        }
    },
    yaroslav: {
        title: "В этом году в Ярославской области выбирают депутата Государственной Думы",
        name: "Кандидат от ЛДПР Лобанова Ирина Валерьевна ",
        description: "51 год, депутат Ярославской областной Думы. 22 года состоит в ЛДПР.",
        photo: '<img src="/src/img/Ярославль-ГД-Лобанова.png" alt="Лобанова">',
        url: {
            vk: '<a href="https://vk.com/id91284005" target="_blank">Вконтакте</a>',
        },
        second: {
            url: {

            },
        }
    },
    magadan: {
        title: "В этом году в Магаданском крае выбирают депутатов Законодательного собрания края",
        name: "Кандидат от ЛДПР Виталий Ненашев",
        description: "47 лет, получил два высших образования в Сибирском Государственном Университете",
        photo: '<img src="/src/img/Магадан-ЗС-Ненашев.png" alt="Ненашев">',
        url: {

        },
        second: {
            url: {

            },
        }
    },
    irkutsk: {
        title: "В этом году в Иркутской области выбирают губернатора",
        name: "Кандидат от ЛДПР Духовников Андрей Михайлович",
        description: "Координатор Иркутского регионального отделения ЛДПР, депутат Ушаковского муниципального образования Иркутской области. Имеет высшее образование, женат, воспитывает двух детей.",
        photo: '<img src="/src/img/Иркутск-Губернатор-Духовников 1.png" alt="Духовников">',
        url: {
            vk: '<a href="https://vk.com/id472460022" target="_blank">Вконтакте</a>',
        },
        second: {
            url: {

            },
        }
    },
    penza: {
        title: "В этом году в Пензенской области выбирают губернатора",
        name: "Кандидат от ЛДПР Васильев Александр Евгеньевич",
        description: "Руководитель фракции ЛДПР в Законодательном Собрании Пензенской области. Женат, воспитывает двух детей",
        photo: '<img src="/src/img/Пенза-Губернатор-Васильев.png" alt="Васильев">',
        url: { 
            vk: '<a href="https://vk.com/vasilev5800" target="_blank">Вконтакте</a>',
            fb: '<a href="https://facebook.com/profile.php?id=100003613715285" target="_blank">Фэйсбук</a>',
            inst: '<a href="https://instagram.com/vasilev58/" target="_blank">Инстаграм</a>'
        },
        second: {
            title: "И выборы депутата Государственной думы",
            name: "Кандидат от ЛДПР Сердовинцев Вадим Юрьевич",
            description: "42 года, имеет высшее образование. Депутат Собрания представителей г. Нижний Ломов Нижнеломовского района. В ЛДПР состоит 8 лет.",
            photo: '<img src="/src/img/Пенза-ГД-Сердовинцев.png" alt="Сердовинцев">',
            url: {
                vk: '<a href=https://vk.com/larzs target="_blank">Вконтакте</a>',
                fb: '<a href="https://www.youtube.com/channel/UCSmXbjTykhCk3NqMWH8ZdCw" target="_blank">Ютуб</a>',
            }, 
        },
    },
    permian: {
        title: "В этом году в Пермском крае выборы губернатора",
        name: "Кандидат от ЛДПР Постников Олег Сергеевич",
        description: "55 лет, имеет высшее образование, депутат Законодательного Собрания Пермского края. Женат, воспитывает сына и дочь.",
        photo: '<img src="/src/img/Пермь-Губернатор-Постников.png" alt="Постников">',
        url: {
            vk: '<a href="https://vk.com/postnikov.ldpr" target="_blank">Вконтакте</a>',
            fb: '<a href="https://www.facebook.com/postnikov.ldpr" target="_blank">Фэйсбук</a>',
            inst: '<a href="https://www.instagram.com/postnikov.ldpr/?hl=ru" target="_blank">Инстаграм</a>'
        },
        second: {
            title: "И выборы депутата Законодательного Собрания Пермского края",
            name: "Кандидат от ЛДПР Балашов Георгий Валерьевич",
            description: "38 лет, женат, воспитывает сына и двух дочерей. Закончил военный Пермский ВКИУ, возглавляет отдел ЖКХ Ленинского района Перми.",
            photo: '<img src="/src/img/Пермь-ЗС-Балашов.png" alt="Балашов">',
            url: {
            }, 
        },
    },
    tatarstan: {
        title: "В этом году в республике Татарстан выборы губернатора",
        name: "Кандидат от ЛДПР Сурчилов Владимир Валерьевич",
        description: "Координатор Татарстанского регионального отделения ЛДПР, 43 года. Высшее образование, в ЛДПР 5 лет.",
        photo: '<img src="/src/img/Татарстан-Сурчилов.png" alt="Сурчилов">',
        url: {
            vk: '<a href="https://vk.com/vova_c" target="_blank">Вконтакте</a>',
        },
        second: {
            title: "И выборы депутата Государственной думы",
            name: "Кандидат от ЛДПР Колосов Андрей Васильевич",
            description: "Директор благотворительного фонда поддержки и сопровождения одаренных детей «Ингениум».",
            photo: '<img src="/src/img/Татарстан-ГД-Колосов.png" alt="Колосов">',
            url: {
                vk: '<a href="https://vk.com/a.kolosov2020" target="_blank">Вконтакте</a>',
            }, 
        },
    },
    chuvashia: {
        title: "В этом году в Чувашской Республике выбирают губернатора",
        name: "Кандидат от ЛДПР Степанов Олег Константинович",
        description: "Руководитель фракции ЛДПР в Государственном Совете Чувашской Республики. Имеет высшее образование, 52 года.",
        photo: '<img src="/src/img/Чувашия-Губернатор-Степанов.png" alt="Степанов">',
        url: { 
            vk: '<a href="https://vk.com/lakost86" target="_blank">Вконтакте</a>',
            fb: '<a href="https://www.facebook.com/KOStepanov" target="_blank">Фэйсбук</a>',
            inst: '<a href="https://www.instagram.com/121konstantin/" target="_blank">Инстаграм</a>'
        },
        second: {
            url: {

            },
        }
    },
    kamchatka: {
        title: "В этом году в Камчатском крае выбирают губернатора",
        name: "Кандидат от ЛДПР Калашников Валерий Юрьевич",
        description: "В ЛДПР 9 лет, высшее образование, депутат Законодательного Собрания Камчатского края, координатор Камчатского регионального отделения ЛДПР, 41 год.",
        photo: '<img src="/src/img/Камчатка-Губернатор-Калашников.png" alt="Калашников">',
        url: {
            vk: '<a href="https://vk.com/v.kalashnikov79" target="_blank">Вконтакте</a>',
        },
        second: {
            url: {

            },
        }
    },
    hmao: {
        title: "В этом году в республике  выбирают губернатора",
        name: "Кандидат от  Андрей ",
        description: "Депутат МО ГО  Отец троих , бывший ",
        url: {
            vk: "vk.com",
            fb: "fb.com",
            inst: "null",
        },
        second: {
            url: {

            },
        }
    },
    krasnodar: {
        title: "В этом году в Краснодарском крае выбирают губернатора",
        name: "Кандидат от ЛДПР Тутушкин Иван Геннадьевич",
        description: "43 года, депутат Заксобрания Краснодарского края, координатор Краснодарского отделения ЛДПР. Окончил НГТУ, кандидат технических наук, офицер, женат, воспитывает пятерых детей.",
        photo: '<img src="/src/img/Краснодар-Губернатор-Тушкин.png" alt="Тутушкин">',
        url: {
            vk: '<a href="https://vk.com/tutushkinig" target="_blank">Вконтакте</a>',
        },
        second: {
            url: {

            },
        }
    },
    rostov: {
        title: "В этом году в Ростовской области выбирают губернатора",
        name: "Кандидат от ЛДПР Пятибратов Пётр Владимирович",
        description: "Координатор Ростовского регионального отделения ЛДПР. Занимается благотворительностью: помогает ветеранам Донского края, детскому дому в городе Шахты, участвовал в восстановлении храма в Ростове.",
        photo: '<img src="/src/img/Ростов-Пятибратов.png" alt="Журавлев">',
        url: {
            vk: '<a href="https://vk.com/id558234817" target="_blank">Вконтакте</a>',
            fb: '<a href="https://www.facebook.com/ppldpr" target="_blank">Фэйсбук</a>',
            inst: '<a href="https://www.instagram.com/petr_paytibratov_ldpr/" target="_blank">Инстаграм</a>'
        },
        second: {
            url: {

            },
        }
    },
    sevastopol: {
        title: "В этом году Севастополе выборы губернатора",
        name: "Кандидат от ЛДПР Журавлев Илья Григорьевич",
        description: "Координатор регионального отделения ЛДПР, депутат Законодательного собрания города Севастополя, отец.",
        photo: '<img src="/src/img/Журавлев.svg" alt="Журавлев">',
        url: {
            fb: '<a href="https://www.facebook.com/iliayzhuravlev" target="_blank">Фэйсбук</a>',
            inst: '<a href="https://instagram.com/il_zhuravlyov?igshid=a6oowq89d2yt" target="_blank">Инстаграм</a>',
        },
        second: {
            title: "И выборы депутата Заксобрания города Севастополя",
            name: "Кандидат от ЛДПР Гацолаев Сергей Викторович",
            description: "Уроженец Севастополя, выпускник военно-морского училища, завершил службу в звании майора. Участвовал в присоединении Крыма, будучи начальником штаба ополчения Ленинского района. В 2014 году вступил в ЛДПР.",
            photo: '<img src="/src/img/Севастополь-Заксоб-Гацолаев.png" alt="Колосов">',
            url: {
                vk: '<a href="https://vk.com/ldpr_sev" target="_blank">ВКонтакте</a>',
                fb: '<a href="https://www.facebook.com/profile.php?id=100043848290807" target="_blank">Фэйсбук</a>',
                inst: '<a href="https://instagram.com/gatsolaevsergei?igshid=e6nrq60x4gc9" target="_blank">Инстаграм</a>',
            }, 
        },
    },




}

cities.addEventListener('click', showDeputy);
cities.addEventListener('click', showDiv);


function showDiv() {
    let depatyDiv = document.querySelector("#carddep");
    depatyDiv.style.visibility = "visible";
}


function showDeputy(event) {

    let targetClickId = event.target.id;
    let title = document.querySelector(".depaty-list__title h2");
    let name = document.querySelector(".cards__title");
    let description = document.querySelector(".cards__description");
    let photo = document.querySelector(".depaty-list__photo");
    let vk = document.querySelector("#vk");
    let fb = document.querySelector("#fb");
    let inst = document.querySelector("#inst");
    // vk.style.display = 'block';
    // inst.style.display = 'block';

    let secondList = document.querySelector("#second-list");
    let secondTitel = document.querySelector("#second-titel");
    let secondName = document.querySelector("#second-name");
    let secondDescription = document.querySelector("#second-description");
    let secondPhoto = document.querySelector("#second-photo");
    let secondVk = document.querySelector("#second-vk");
    let secondFb = document.querySelector("#second-fb");
    let secondInst = document.querySelector("#second-inst");

    if (depatylist[targetClickId].second.photo == undefined) {
        secondList.style.display = 'none';
    } else {
        secondList.style.display = 'block';
    }



    if (depatylist[targetClickId].url.inst == undefined) {
        inst.style.display = 'none';
    } else {
        inst.style.display = 'block';
    }

    if (depatylist[targetClickId].url.vk == undefined) {
        vk.style.display = 'none';
    } else {
        vk.style.display = 'block';
    }

    if (depatylist[targetClickId].url.fb == undefined) {
        fb.style.display = 'none';
    } else {
        fb.style.display = 'block';
    }



    if (depatylist[targetClickId].second.url.inst == undefined) {
        secondInst.style.display = 'none';
    } else {
        secondInst.style.display = 'block';
    }

    if (depatylist[targetClickId].second.url.vk == undefined) {
        secondVk.style.display = 'none';
    } else {
        secondVk.style.display = 'block';
    }

    if (depatylist[targetClickId].second.url.fb == undefined) {
        secondFb.style.display = 'none';
    } else {
        secondFb.style.display = 'block';
    }
    
    title.innerText = depatylist[targetClickId].title;

    name.innerText = depatylist[targetClickId].name;
    description.innerText = depatylist[targetClickId].description;
    photo.innerHTML = depatylist[targetClickId].photo;
    vk.innerHTML = depatylist[targetClickId].url.vk;
    fb.innerHTML = depatylist[targetClickId].url.fb;
    inst.innerHTML = depatylist[targetClickId].url.inst;

    secondTitel.innerText = depatylist[targetClickId].second.title;
    secondName.innerText = depatylist[targetClickId].second.name;
    secondDescription.innerText = depatylist[targetClickId].second.description;
    secondPhoto.innerHTML = depatylist[targetClickId].second.photo;
    secondVk.innerHTML = depatylist[targetClickId].second.url.vk;
    secondFb.innerHTML = depatylist[targetClickId].second.url.fb;
    secondInst.innerHTML = depatylist[targetClickId].second.url.inst;

    // if (depatylist[targetClickId].url.vk === null) {
    //     vk.style.display = 'none';
    // }

    // if (depatylist[targetClickId].url.inst === null) {
    //     inst.style.display = 'none';
    // }

    // if (depatylist[targetClickId].second.url.inst === null) {
    //     inst.style.display = 'none';
    // }
}


